export default __webpack_public_path__ + "assets/woff/3eca5d9d5340a91caabcdf3fc777af42.woff";